module.exports = __webpack_public_path__ + "static/media/c3_levels_3-6.0a833918.png";